import en from './lang/en'
import pt from './lang/pt'

const messages = {
  'en': en,
  'pt': pt
}

export default messages



// WEBPACK FOOTER //
// ./src/translations/translations.js